import { Fragment, useContext, useEffect, useState } from "react";
import { ConvertToFloat, isValidArray } from "../../../Layout/Common/common";
import { ImageWithDefault } from "../../../Layout/Common/imageWithDefault";
import { Link } from "react-router-dom";
import { QuantityStripper } from "../../../Layout/Common/quantityStripper";
import { axiosInstance } from "../../../axios/axiosInstance";
import { GlobalContext } from "../../../Context/GlobalContext";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import "../../../assets/css/cartList.css";
import { ISPICKUPONLY_MESSAGE } from "../../../constants";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { PAGES } from "../../../routeConfig";
import { ProductLink } from "../../Common/productLink";
import { ItemReferenceInput } from "../../Common/itemReferenceInput";

export const CartItemBody = ({ cartItemList, totalItem, showToaster = true }) => {
  const [cartItem, setCartItem] = useState(null);
  const [cartItemTotal, setCartItemTotal] = useState(0);
  const { handleDeleteCartItem, deletingProdIds } = useGlobalFunction();
  useEffect(() => {
    if (isValidArray(cartItemList)) {
      setCartItem(cartItemList);
      setCartItemTotal(totalItem);
    }
  }, [cartItemList, totalItem]);
  const removeCard = (item) => {
    handleDeleteCartItem(item.prod_id, item.order_item_id, showToaster);
  };

  return (
    <Fragment>
      {isValidArray(cartItem) && (
        <div className="added-cartPopup">
          <TransitionGroup>
            {cartItem.slice(0, 50).map((item, index) => (
              <CSSTransition key={item.prod_id} timeout={300} classNames="card">
                <CartPopupItem
                  item={item}
                  index={index}
                  isDeleting={deletingProdIds?.has(item.prod_id) ?? false}
                  showToaster={showToaster}
                  onRemove={removeCard}
                />
              </CSSTransition>
            ))}
          </TransitionGroup>
          {cartItem.length < cartItemTotal && (
            <Link to={PAGES.ORDER_DETAIL} className="view-more-items">
              <em>View more items in your cart...</em>
            </Link>
          )}
        </div>
      )}
    </Fragment>
  );
};

const CartPopupItem = ({ item, index, isDeleting, showToaster, onRemove }) => {
  const globalcontext = useContext(GlobalContext);

  return (
    <div
      className="added-cartPro flex-column"
      key={index}
      data-id={item.prod_id}
      style={{ opacity: isDeleting ? 0.5 : 1 }}
    >
      <div className="d-flex align-items-start gap-3 w-100">
        <div className="added-cartPro-img">
          <ImageWithDefault src={item.image_th} alt="Product-image" />
        </div>
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="d-flex justify-content-between align-items-start gap-2">
            <div className="added-cartPro-item">
              <h6 className="mb-1">
                <ProductLink to={item.product_url}>{item.description}</ProductLink>
              </h6>
              {isValidArray(globalcontext.pickupOnlyProduct) &&
                globalcontext.pickupOnlyProduct.includes(String(item.prod_id)) && (
                  <div className="text-danger form-validation-message">{ISPICKUPONLY_MESSAGE}</div>
                )}
              <p className="mb-0">
                <span>Code : {item.prod_code}</span>
              </p>
              <p className="mb-0">
                <span>${ConvertToFloat(item.price_ext_applied)} each</span>
              </p>
            </div>
            <div className="d-flex flex-column align-items-end gap-1 flex-shrink-0">
              <button
                type="button"
                className="btn btn-link p-0 text-secondary mb-0"
                aria-label="Remove item"
                disabled={isDeleting}
                onClick={() => {
                  onRemove(item);
                }}
              >
                <i className="fa-regular fa-trash-can" />
              </button>
              <span className="fw-bold fs-14 text-nowrap">${ConvertToFloat(item.total_ext)}</span>
            </div>
          </div>
          <div className="added-cartPro-price align-items-center mt-2">
            <div className="me-2" style={{ flex: "1 1 0", minWidth: 0 }}>
              <ItemReferenceInput item={item} className="" />
            </div>
            <QuantityStripper
              inline={false}
              prd={item}
              showToaster={showToaster}
              className="mt-0"
              params={{
                code: item.prod_code,
                desc: item.description,
                img: item.image_th,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
